import React from "react";

function Book() {
  return (
    <section
      className="ftco-section contact-section ftco-no-pb"
      id="contact-section"
    >
      <div className="container ftco-about">
        <div className="row d-flex">
          <div className="col-md-12">
            <div className="row justify-content-start pb-3">
              <div className="col-md-12 heading-section">
                <h2 className="mb-12">Book a Slot</h2>
                <div className="d-flex flex-wrap justify-content-between">
                <iframe
                  src="https://app.calendarbridge.com/book/harjeevan/"
                  title="Book a time with Harjeevan"
                  className="embedded-iframe"
                  style={{
                    width: "100%",
                    height: "800px", // Adjust height as needed
                    border: "none",
                    overflow: "hidden",
                  }}
                />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Book;
